<template>
<div class="collapsible">
    <div class="flex justify-between question" @click="open = !open">
        <button class="title oswald-400" type="button">
            <slot name="title"></slot>
        </button>
        <svg class="collapsible-icon" :class="{ 'rotate': open }" width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.00004 2.67643L1.33332 7.13092L0 5.8582L6.00004 0.13092L12 5.8582L10.6667 7.13092L6.00004 2.67643Z" fill="black"/>
        </svg>
    </div>
    <div class="collapsible-content montserrat-400" v-if="open">
        <slot></slot>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            open: false,
        }
    },
};
</script>
